"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalMessage = getInternalMessage;
exports.handleSdkMessage = handleSdkMessage;
exports.sendSetupComplete = sendSetupComplete;
exports.sendCapabilities = sendCapabilities;
exports.areThirdPartyCookiesEnabled = areThirdPartyCookiesEnabled;
const versions_1 = require("../versions");
const port_1 = require("./port");
const version_json_1 = require("../version.json");
const constants_1 = require("../constants");
const const_1 = require("./const");
const features_1 = require("../features");
const track_1 = require("../track");
const memoryUsage_1 = require("../memoryUsage");
/**
 * Handler for the data received that is for the SDK
 */
function handleSdkMessage(message) {
    const { name, value } = message;
    if (name === const_1.RECEIVE_INTERNAL_MESSAGE.VERSIONS) {
        (0, versions_1.setVersions)(value);
    }
    else if (name === const_1.RECEIVE_INTERNAL_MESSAGE.FEATURE_FLAGS) {
        (0, features_1.setFeatures)(value);
        const isTrackFocusEnabled = (0, features_1.getFeature)("trackFocus");
        if (isTrackFocusEnabled) {
            (0, track_1.initTracking)();
        }
        const isReportMemoryUsageEnabled = (0, features_1.getFeature)("reportMemoryUsage");
        if (isReportMemoryUsageEnabled) {
            (0, memoryUsage_1.initMemoryUsageReporting)();
        }
    }
}
/**
 * Construct the data that will be sent to the parent-sdk
 */
function getInternalMessage(message) {
    return {
        type: constants_1.INTERNAL_MESSAGE_TYPE,
        message,
    };
}
/**
 * Checks if 3rd party cookies are enabled.
 */
function areThirdPartyCookiesEnabled() {
    try {
        document.cookie = "thirdparty_test=1; SameSite=None; Secure";
        return document.cookie.indexOf("thirdparty_test=1") !== -1;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Send a message to the parent-sdk with the name as "capabilities"
 */
function sendCapabilities() {
    const thirdPartyCookiesEnabled = areThirdPartyCookiesEnabled();
    const data = getInternalMessage({ name: const_1.SEND_INTERNAL_MESSAGE.CAPABILITIES, value: { thirdPartyCookiesEnabled } });
    (0, port_1.sendMessage)(data);
}
/**
 * Send a message to the parent-sdk with the name as "setup-complete"
 */
function sendSetupComplete() {
    const data = getInternalMessage({ name: const_1.SEND_INTERNAL_MESSAGE.SETUP_COMPLETE, value: { version: version_json_1.version } });
    (0, port_1.sendMessage)(data);
}
//# sourceMappingURL=internal.js.map